"use strict";Object.defineProperty(exports, "__esModule", {value: true});






var _helpers = require('shared/actions/helpers');
var _utils = require('shared/store/utils');

const setPatientPhotoActions = _utils.createAsyncActions('SetPatientPhoto')
const startPatientAddEmailActions = _utils.createAsyncActions('StartPatientAddEmail')
const verifyPatientAddEmailActions = _utils.createAsyncActions('VerifyPatientAddEmail')
const requestAccountDeletionActions = _utils.createAsyncActions('RequestAccountDeletion')

 const actionCreators = {
  setPatientPhotoActions,
  startPatientAddEmailActions,
  verifyPatientAddEmailActions,
  requestAccountDeletionActions,
}; exports.actionCreators = actionCreators

// "" removes the photo.
const setPatientPhoto = (Ref) =>
  _helpers.wsCommand('SetPatientPhoto', setPatientPhotoActions, { Ref }, null)

const startPatientAddEmail = (req) =>
  _helpers.wsCommand('StartPatientAddEmail', startPatientAddEmailActions, req, null)

const verifyPatientAddEmail = (ChallengeKey, Code) =>
  _helpers.wsCommand(
    'VerifyPatientAddEmail',
    verifyPatientAddEmailActions,
    { ChallengeKey, Code },
    null,
  )

// Profile & settings' Delete account: Support gets a ticket about this patient.
const requestAccountDeletion = () =>
  _helpers.wsCommand('RequestAccountDeletion', requestAccountDeletionActions, {}, null)

exports. default = {
  setPatientPhoto,
  startPatientAddEmail,
  verifyPatientAddEmail,
  requestAccountDeletion,
}
